import type { Feature, FeatureCollection, Point } from 'geojson'
import type { MonitoringSite, ToGeoJSON } from '../../../types/apiModels'
import type { MonitoringSiteMarkerProperties } from '../../Map/monitoringSiteMarkers'

export type MonitoringSiteFeature = Feature<Point, MonitoringSiteMarkerProperties>

export const toMonitoringSitesFeatureCollection = (
  sites: MonitoringSite[] | undefined,
  samplingAreas: ToGeoJSON[],
): FeatureCollection<Point, MonitoringSiteMarkerProperties> | null => {
  const colorBySamplingArea = new Map(
    samplingAreas.map(area => [area.properties.id, area.properties.color]),
  )

  const features = (sites ?? []).flatMap<MonitoringSiteFeature>(site =>
    site.toGeoJSON
      ? [
          {
            ...site.toGeoJSON,
            properties: {
              ...site.toGeoJSON.properties,
              isRandomSite: Boolean(site.isRandomSite),
              color: site.samplingAreaId ? colorBySamplingArea.get(site.samplingAreaId) : undefined,
            },
          },
        ]
      : [],
  )

  return features.length ? { type: 'FeatureCollection', features } : null
}
